var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.7499 14.976L20.9899 0L1.27794 30.272C1.17127 30.4427 1.10727 30.6347 1.08594 30.848C1.08594 31.0613 1.13927 31.2533 1.24594 31.424C1.3526 31.5947 1.49127 31.7333 1.66194 31.84C1.85394 31.9467 2.04594 32 2.23794 32C2.42994 32 2.6006 31.9573 2.74994 31.872C2.9206 31.7867 3.05927 31.6693 3.16594 31.52L12.8299 16.736H29.7899C30.0033 16.7573 30.1953 16.7147 30.3659 16.608C30.5579 16.48 30.6966 16.3307 30.7819 16.16C30.8886 15.968 30.9313 15.7653 30.9099 15.552C30.9099 15.3387 30.8566 15.1467 30.7499 14.976ZM27.5819 14.464H14.2379L20.9579 4.192L27.5819 14.464Z",
    fill: "#474747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.925d87067b8633459fe2e958fe10b64a.svg";
export { ForwardRef as ReactComponent };